module.exports = __webpack_public_path__ + "media/images/resource-placeholder04-621f8fde90314bbd357b9e8136b05299.jpg";